module.exports = __webpack_public_path__ + "static/media/background1.2bee70c1.jpg";